<template>
  <div>
    <page-main
      ref="main"
      :tableData="tableData"
      :loading="loading"
      @openDetailDialog="openDetailDialog"
      @reload="$refs.header.query()"
    >
      <page-header ref="header" slot="header" @query="getData" />
    </page-main>

    <DemandDetailDialog
      :visible.sync="detailDialogOptions.visible"
      :title="$l('INDEX.dialog_title_accessories_detail') || '订单辅料信息详情'"
      :orderMaterialCode="detailDialogOptions.code"
    />
  </div>
</template>
<script>
import PageMain from './main'
import PageHeader from './header'
import DemandDetailDialog from '../detail/dialog.vue'
export default {
  components: { PageHeader, PageMain, DemandDetailDialog },
  props: { orderCode: { type: String, default: '' } },
  data() {
    return {
      tableData: [],
      loading: false,
      detailDialogOptions: {
        visible: false,
        code: '',
      },
    }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .pendingOrderDemandMaterialListApi({
          orderCode: this.orderCode,
          ...form,
        })
        .then((res) => {
          this.loading = false
          this.tableData = res.body.data
        })
        .catch(() => {
          this.loading = false
        })
    },
    openDetailDialog({ orderMaterialCode }) {
      this.detailDialogOptions = {
        visible: true,
        code: orderMaterialCode,
      }
    },
  },
}
</script>
